import SvgIcon from "@material-ui/core/SvgIcon";
import * as React from "react";

function MarkChatRead(props) {
  const {style} = props;
  return (
    <SvgIcon {...props} style={style} viewBox="0 -960 960 960">
      <path
        fill="rgb(0, 0, 0, 0.54)"
        d="M694-160 553-302l56-56 85 85 170-170 56 57-226 226ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v280h-80v-280H160v525l46-45h274v80H240L80-80Zm80-240v-480 480Z"
      />
    </SvgIcon>
  );
}

export default MarkChatRead;
